export const ADDTO_WISHLISTCART = "ADDTO_WISHLIST"
export const ADDTO_WISHLISTCART_SUCCESS = "ADDTO_WISHLIST_SUCCESS";
export const ADDTO_WISHLISTCART_FAILURE = "ADDTO_WISHLIST_FAILURE";
export const DELETE_WISHLISTCART = "DELETE_WISHLISTCART";
export const DELETE_WISHLISTCART_SUCCESS = "DELETE_WISHLISTCART_SUCCESS";
export const DELETE_WISHLISTCART_FAILURE = "DELETE_WISHLISTCART_FAILURE"
export const DELETE_WISHLISTCART_FAIL = "DELETE_WISHLISTCART_FAIL";
export const FETCH_WISHLISTCART_COUNT = "FETCH_WISHLISTCART_COUNT";
export const FETCH_WISHLISTCART_COUNT_SUCCESS = "FETCH_WISHLISTCART_COUNT_SUCCESS";
export const FETCH_WISHLIST = "FETCH_WISHLIST";
export const FETCH_WISHLIST_SUCCESS = "FETCH_WISHLIST_SUCCESS";
export const FETCH_WISHLIST_FAIL = "FETCH_WISHLIST_FAIL";
export const FETCH_CART = "FETCH_CART";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_FAIL = "FETCH_CART_FAIL";
export const INCREASE_WISHLISTQUENTITY = "INCREASE_WISHLISTQUENTITY";
export const INCREASE_WISHLISTQUENTITY_SUCCESS = "INCREASE_WISHLISTQUENTITY_SUCCESS";
export const INCREASE_WISHLISTQUENTITY_FAIL = "INCREASE_WISHLISTQUENTITY_FAIL";
export const DECREASE_WISHLISTQUENTITY = "DECREASE_WISHLISTQUENTITY";
export const DECREASE_WISHLISTQUENTITY_SUCCESS = "DECREASE_WISHLISTQUENTITY_SUCCESS";
export const DECREASE_WISHLISTQUENTITY_FAIL = "DECREASE_WISHLISTQUENTITY_FAIL";
export const INCREASE_CARTQUENTITY = "INCREASE_CARTQUENTITY";
export const INCREASE_CARTQUENTITY_SUCCESS = "INCREASE_CARTQUENTITY_SUCCESS";
export const INCREASE_CARTQUENTITY_FAIL = "INCREASE_CARTQUENTITY_FAIL";
export const DECREASE_CARTQUENTITY = "DECREASE_CARTQUENTITY";
export const DECREASE_CARTQUENTITY_SUCCESS = "DECREASE_CARTQUENTITY_SUCCESS";
export const DECREASE_CARTQUENTITY_FAIL = "DECREASE_CARTQUENTITY_FAIL";
